export const GET_QUESTIONS = 'getQuestions'
export const SET_QUESTIONS = 'setQuestions'
export const SUBMIT_SURVEY = 'submitSurvey'
export const SET_LIST_LOADING = 'setListLoading'
